var map = {
	"./ar/canvas.json": "./src/locale/ar/canvas.json",
	"./cs/canvas.json": "./src/locale/cs/canvas.json",
	"./cy/canvas.json": "./src/locale/cy/canvas.json",
	"./da/canvas.json": "./src/locale/da/canvas.json",
	"./de/canvas.json": "./src/locale/de/canvas.json",
	"./en/canvas.json": "./src/locale/en/canvas.json",
	"./es/canvas.json": "./src/locale/es/canvas.json",
	"./fi/canvas.json": "./src/locale/fi/canvas.json",
	"./fr/canvas.json": "./src/locale/fr/canvas.json",
	"./he/canvas.json": "./src/locale/he/canvas.json",
	"./hr/canvas.json": "./src/locale/hr/canvas.json",
	"./hu/canvas.json": "./src/locale/hu/canvas.json",
	"./it/canvas.json": "./src/locale/it/canvas.json",
	"./ja/canvas.json": "./src/locale/ja/canvas.json",
	"./kk/canvas.json": "./src/locale/kk/canvas.json",
	"./ko/canvas.json": "./src/locale/ko/canvas.json",
	"./nl/canvas.json": "./src/locale/nl/canvas.json",
	"./pl/canvas.json": "./src/locale/pl/canvas.json",
	"./pt/canvas.json": "./src/locale/pt/canvas.json",
	"./ro/canvas.json": "./src/locale/ro/canvas.json",
	"./ru/canvas.json": "./src/locale/ru/canvas.json",
	"./sh/canvas.json": "./src/locale/sh/canvas.json",
	"./sk/canvas.json": "./src/locale/sk/canvas.json",
	"./sr/canvas.json": "./src/locale/sr/canvas.json",
	"./sv/canvas.json": "./src/locale/sv/canvas.json",
	"./vi/canvas.json": "./src/locale/vi/canvas.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locale sync recursive ^\\.\\/.*\\/canvas\\.json$";